 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		10: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"framework","1":"commons","2":"29107295","3":"722d17bab2f16fec4d6bb08a4889104e29496ce6","4":"eb9059b509ab12f8f73825ef588fa39f326c9540","5":"246738ab98c303ff752e2796455282ca3ed2b68c","6":"377cfe6b2b9e7b5845e0502f9c0f25436c8889ac","7":"e351fd2c1ed954ac09936d5336711540192e2160","8":"1cda1ecc17a453f1787f8e7faf0bb4ae51e19a7d","9":"5022c8c537bdb4bb82ebea876170e16d15b0bb51","11":"36bcf0ca","13":"component---src-pages-404-jsx","14":"component---src-pages-authors-jsx","15":"component---src-pages-bankruptcy-tsx","16":"component---src-pages-browse-jsx","17":"component---src-pages-careers-jsx","18":"component---src-pages-donate-jsx","19":"component---src-pages-donations-jsx","20":"component---src-pages-fresh-starts-jsx","21":"component---src-pages-get-in-touch-jsx","22":"component---src-pages-index-jsx","23":"component---src-pages-learn-jsx","24":"component---src-pages-legal-definitions-jsx","25":"component---src-pages-legalaidlocator-jsx","26":"component---src-pages-press-jsx","27":"component---src-pages-reviews-jsx","28":"component---src-pages-search-jsx","29":"component---src-pages-team-jsx","30":"component---src-pages-tools-debt-repayment-calculator-tsx","31":"component---src-pages-tools-jsx","32":"component---src-templates-author-profile-jsx","33":"component---src-templates-fresh-start-diary-jsx","34":"component---src-templates-glossary-definition-jsx","35":"component---src-templates-learn-article-jsx","36":"component---src-templates-learn-article-tag-jsx","37":"component---src-templates-page-template-jsx"}[chunkId]||chunkId) + "-" + {"0":"8c05b62f1d6ae50e9332","1":"e0be9d134ab325491a23","2":"42402af61ecb67fe3eef","3":"35c90de16a2884e05f9b","4":"1c23f4a852d3c7ba0ffe","5":"30ed68eec0e0efc04b43","6":"60a3ce8b69f78e594a54","7":"e50d19368a536443e30d","8":"421ff3a5b43382c7b8c8","9":"88aa7a1361ffccf3df47","11":"c4eada79843f2a206134","13":"a5d7c55b6769e8a8deb3","14":"c02bee86bfb6f998591c","15":"e01a116906717a398e4e","16":"05787a4ed9e0f5ea5c4a","17":"496ad03c16d5494f2199","18":"32d4d82a7397e99c905c","19":"52c42c224f789dce5cfc","20":"339e9159e9fd7ab774fd","21":"aac3197363b0f3da7ad0","22":"997a691122c88b3721e3","23":"e809f3b6b65c8cd0de9c","24":"220437df9b785a83d4d3","25":"bfadd6cab46658db3af5","26":"daec1cddfcf13892a11f","27":"bf40bf9119297a953e67","28":"145bd848575849b4062f","29":"c861a73072bc5926fc06","30":"fd5aa9c4c9e25d42f50b","31":"d7f9ce036804d6cd3724","32":"9c4ef5b5e00658713aa0","33":"000a40a929f06a6731eb","34":"9891c3220f89baf989b4","35":"099fefede2f50946d747","36":"23d99c095f2b201b6308","37":"0d935dc7c95c25337371"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
